import { FILTER_LABELS } from './filters';

const SITE = 'https://imagecat.ru';
const DEFAULT_TITLE = 'imagecat — фотки котов';
const DEFAULT_DESC = 'Фотки котов. Собираю с 2001.';

function upsertMeta(property: string, content: string, attr: 'property' | 'name' = 'property'): void {
  let el = document.querySelector<HTMLMetaElement>(`meta[${attr}="${property}"]`);
  if (!el) {
    el = document.createElement('meta');
    el.setAttribute(attr, property);
    document.head.appendChild(el);
  }
  el.content = content;
}

export function updateSeo(filter: string, path: string): void {
  const label = FILTER_LABELS[filter] || filter;
  const isHome = filter === 'all';
  const title = isHome ? DEFAULT_TITLE : `${label} — imagecat`;
  const description = isHome
    ? DEFAULT_DESC
    : `Котики: ${label}. ${DEFAULT_DESC}`;
  const url = SITE + path;

  document.title = title;
  upsertMeta('description', description, 'name');
  upsertMeta('og:title', title);
  upsertMeta('og:description', description);
  upsertMeta('og:url', url);
  upsertMeta('og:type', 'website');
  upsertMeta('og:site_name', 'imagecat.ru');
  upsertMeta('og:image', `${SITE}/assets/img/logo.svg`);
  upsertMeta('twitter:card', 'summary', 'name');
  upsertMeta('twitter:title', title, 'name');
  upsertMeta('twitter:description', description, 'name');

  let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
}

export function updatePermalinkSeo(publicId: string, width: number, height: number, imageUrl?: string): void {
  const title = `котик ${publicId} — imagecat`;
  const description = `Фото котика на imagecat.ru · ${width}×${height}`;
  const url = `${SITE}/i/${publicId}`;

  document.title = title;
  upsertMeta('description', description, 'name');
  upsertMeta('og:title', title);
  upsertMeta('og:description', description);
  upsertMeta('og:url', url);
  upsertMeta('og:type', 'article');
  upsertMeta('og:image', imageUrl ?? `${SITE}/assets/img/logo.svg`);
  upsertMeta('twitter:card', 'summary_large_image', 'name');
  upsertMeta('twitter:title', title, 'name');

  let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) {
    canonical = document.createElement('link');
    canonical.rel = 'canonical';
    document.head.appendChild(canonical);
  }
  canonical.href = url;
}
